import { Classroom } from 'types/classroom';
import { orderByNiveau } from 'utils/orderByNiveau';
import { Row } from '@tanstack/react-table';

export function sortClassrooms(
  rowA: Row<any>,
  rowB: Row<any>,
  columnId: string,
  classrooms: Classroom[],
) {
  const val1 = rowA.getValue(columnId);
  const val2 = rowB.getValue(columnId);
  if (!val1 || !val2) {
    return 0;
  }
  if (typeof val1 !== 'string' || typeof val2 !== 'string') {
    return 0;
  }
  if (val1 === val2) {
    return 0;
  }
  const classroom1 = classrooms.find(c => c.id === val1)?.name;
  const classroom2 = classrooms.find(c => c.id === val2)?.name;
  if (!classroom1 || !classroom2) {
    return 0;
  }
  const rowsOrdered = orderByNiveau([classroom1, classroom2]);
  if (rowsOrdered[0] === classroom1) {
    return -1;
  }
  return 1;
}
